import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { analyticsPath, apiClient } from '@/lib/api-client';
import { adaptOverview, type ApiAnalyticsOverview } from '@/lib/analytics-adapters';
import type { AnalyticsOverview } from '@/types/analytics';

import { analyticsKeys } from './analytics-keys';

export function useAnalyticsOverview(): UseQueryResult<AnalyticsOverview, Error> {
  return useQuery({
    queryKey: analyticsKeys.overview(),
    queryFn: async ({ signal }) =>
      adaptOverview(await apiClient.get<ApiAnalyticsOverview>(analyticsPath('/overview'), signal)),
    refetchInterval: 30_000,
  });
}
